import {
    unstable_createMuiStrictModeTheme as createMuiTheme,
    ThemeProvider
} from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import './App.css';
import CUNotFound from './components/CUNotFound';
import Header from './components/Header';
import MultiStepForm from './components/MultiStepForm';
import { getCuCode } from './utils';

const customTheme = createMuiTheme({
    typography: {
        subtitle2: {
            fontSize: 18
        },
        h6: {
            fontSize: 18
        }
    },
    palette: {
        primary: {
            main: blue[700]
        }
    },
    overrides: {
        MuiInputLabel: {
            outlined: {
                backgroundColor: '#F9FAFB',
                paddingLeft: 2,
                paddingRight: 2
            }
        }
    }
});

function App() {
    const CU_CODE = getCuCode();
    return (
        <ThemeProvider theme={customTheme}>
            <div className="bg-white">
                {window.location !== window.parent.location || !CU_CODE ? null : <Header />}
                {CU_CODE ? <MultiStepForm /> : <CUNotFound />}
            </div>
        </ThemeProvider>
    );
}

export default App;
